import { useTranslation } from "react-i18next";
import { PlayCircle } from "lucide-react";

const SRC = (process.env.REACT_APP_INTRO_VIDEO_URL || "").trim();
const CAPTIONS = (process.env.REACT_APP_INTRO_VIDEO_CAPTIONS_URL || "").trim();

function embedUrl(src) {
  const yt = src.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{6,})/);
  if (yt) return `https://www.youtube-nocookie.com/embed/${yt[1]}?autoplay=0&rel=0`;
  const vm = src.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}?autoplay=0&dnt=1`;
  return null;
}

export function HeroVideo() {
  const { t, i18n } = useTranslation();
  const frame = "relative aspect-video w-full overflow-hidden rounded-3xl border border-ink/10 shadow-lift lg:aspect-auto lg:h-full";
  if (!SRC) {
    return (
      <div className={`${frame} grid place-items-center bg-ink text-white`} data-testid="hero-video-placeholder" role="img" aria-label={t("b6.video_soon")}>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_28%_22%,hsl(var(--clay)/0.6),transparent_55%),radial-gradient(circle_at_82%_88%,hsl(var(--sage-strong)/0.45),transparent_50%)]" aria-hidden />
        <div className="absolute inset-3 rounded-[18px] border border-white/15" aria-hidden />
        <div className="relative flex flex-col items-center gap-4 px-6 text-center">
          <span className="grid h-16 w-16 place-items-center rounded-full bg-white/10 ring-1 ring-white/40 backdrop-blur-sm sm:h-20 sm:w-20"><PlayCircle className="h-8 w-8 sm:h-10 sm:w-10" strokeWidth={1.5} aria-hidden /></span>
          <p className="font-display text-lg font-semibold sm:text-2xl" data-testid="hero-video-soon">{t("b6.video_soon")}</p>
        </div>
      </div>
    );
  }
  const embed = embedUrl(SRC);
  if (embed) return <div className={frame} data-testid="hero-video"><iframe src={embed} title={t("b6.video_title")} className="absolute inset-0 h-full w-full" allow="encrypted-media; picture-in-picture; fullscreen" allowFullScreen loading="lazy" /></div>;
  return (
    <div className={`${frame} bg-black`} data-testid="hero-video">
      <video className="absolute inset-0 h-full w-full object-contain" controls preload="metadata" playsInline src={SRC} data-testid="hero-video-player" aria-label={t("b6.video_title")}>
        {CAPTIONS && <track kind="captions" src={CAPTIONS} srcLang={i18n.language?.startsWith("ru") ? "ru" : "en"} label={t("b6.captions")} default />}
      </video>
    </div>
  );
}
